import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loading } from '@wayste/sour-ui';
export const Loader = ({ isLoading, message }) => {
    if (!isLoading)
        return null;
    return (_jsxs("div", { className: "fixed inset-0 z-[100000] flex flex-col items-center justify-center bg-black bg-opacity-50 text-white", children: [_jsx(Loading, { className: "size-12 text-white" }), _jsx("p", { className: "mt-3", children: message ?? 'Loading...' })] }));
};
//# sourceMappingURL=loader.js.map